<template>
  <div class="main">
    <div class="title">
      <div class="name">机构信息</div>
    </div>
    <div class="box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="机构LOGO" prop="img" >
              <div class="img-box">
                <el-upload
                    class="avatar-uploader"
                    accept="image/png,image/gif,image/jpeg"
                    :action="fileUpUrl"
                    :data="Data"
                    :show-file-list="false"
                    :on-error="uploadError"
                    :on-success="uploadSuccess"
                    :before-upload="beforeAvatarUpload">
                  <img :src="ruleForm.img" v-if="ruleForm.img" alt="">
                  <div v-else style="height: 121px;width: 121px;margin-left: 28px;border-radius: 60px; border: 1px solid #0a2240;"></div>
                  <div class="tex">
                    <p>点击上传</p>
                    <span>推荐尺寸：120×120px，5M以内</span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="机构名称" prop="jgname">
              <el-input v-model="ruleForm.jgname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系人" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="机构地址" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="网址" prop="website">
              <el-input v-model="ruleForm.website"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="简介" prop="content" required>
              <ck-decoupled-editor ref="editor" :content="ruleForm.content"></ck-decoupled-editor>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="">
              <span class="btn3" @click="submitForm('ruleForm')">提交</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import CkDecoupledEditor from "@/components/CKDecoupledEditor";
import {getParentInfo, setParentInfo} from "@/api/index";
export default {
  name: "information",
  data() {
    // var validateImg = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请上传机构logo'));
    //   } else {
    //     if (this.ruleForm.img !== '') {
    //       this.$refs.ruleForm.validateField('img');
    //     }
    //     callback();
    //   }
    // };
    return {
      fileUpUrl: 'http://fw.zhichenghui.org.cn/index.php/home/img/upload',
      id:'',
      Data:{
        path:1,
        uptype:1
      },
      ruleForm: {
        img: '',
        jgname:'',
        name:'',
        phone:'',
        address:'',
        email:'',
        website:'',
        content:''
      },
      rules: {
        img: [
          { required: true, message: '请上传logo', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ],
        jgname: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 7, max: 11, message: '请输入座机号码或手机号码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入机构地址', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        website: [
          { required: true, message: '请输入网址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {CkDecoupledEditor},
  created() {
    this.$emit("setActive", {
      active: 2,
      act: 0,
      name: '机构管理 > 机构信息'
    })
    this.getInfo()
  },
  methods: {
    submitForm(formName) {
      let _info = this.$refs.editor.getInfo();
      this.ruleForm.content = _info.content;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setInfo()
        } else {
          this.$message.error('请填写完整..')
          return false;
        }
      });
    },
    // 提交
    async setInfo() {
      let _res = await setParentInfo(
          this.user.mid,
          this.ruleForm.img,
          this.ruleForm.jgname,
          this.ruleForm.name,
          this.ruleForm.phone,
          this.ruleForm.address,
          this.ruleForm.email,
          this.ruleForm.website,
          this.ruleForm.content
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
      } else {
        this.$message.error(_res.msg)
      }
    },

    // 获取详情
    async getInfo() {
      let _res = await getParentInfo(
          this.user.mid
      );
      if (_res.status === 200) {
        console.log(_res)
        this.ruleForm.img = _res.data.morglogo
        this.ruleForm.jgname = _res.data.morgname
        this.ruleForm.name = _res.data.contacts
        this.ruleForm.phone = _res.data.morgtel
        this.ruleForm.address = _res.data.address
        this.ruleForm.email = _res.data.morgemail
        this.ruleForm.website = _res.data.morgurl
        this.ruleForm.content = _res.data.morgdesc
      } else {
        this.$message.error(_res.msg)
      }
    },


    //  上传成功
    uploadSuccess(response) {
      this.uping.close();
      if (response.code === 1) {
        this.ruleForm.img = 'http://fw.zhichenghui.org.cn/' + response.path
      } else {
        this.$message.success(response.msg)
      }
    },

    //  上传失败
    uploadError() {
      this.uping.close();
      this.$message({
        message: "上传出错，请重试！",
        type: "error",
        center: true,
      });
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }

      this.uping = this.$loading({
        lock: true,
        text: "上传中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
      });
    },

  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">

.btn3 {
  display: block;
  width: 120px;
  height: 40px;
  background-color: #ff9600;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.img-box {
  width: 100%;
  //height: 164px;

  position: relative;
  overflow: hidden;

  .avatar-uploader {
    //height: 164px;

    .tex {
      width: 185px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      p {
        width: 100px;
        height: 35px;
        text-align: center;
        font-size: 14px;
        background-color: #0a2240;
        color: #ffffff;
        line-height: 35px;
        cursor: pointer;
        border-radius: 17px;
        margin-top: 10px;
      }
      span {
        font-size: 12px;
        color: #999;
      }
    }
    img {
      width: 121px;
      height: 121px;
      object-fit: scale-down;
      border: 1px solid #0a2240;
      border-radius: 60px;
    }
  }
}
.main {
  display: flex;
  flex-direction: column;
  .title {
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }
  .box {
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    background-color: #ffffff;
    flex: 1;
  }
}
</style>


